import { EmailPromptModal } from './EmailPromptModal';
import { CodeVerificationModal } from './CodeVerificationModal/CodeVerificationModal';
import {
  STEP_NAME,
  StepName,
  useUpdateSignInEmailFlow,
} from './useUpdateSignInEmailFlow.hook';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onAbandon: (step: StepName) => void;
  currentEmail: string | null;
  title?: string;
  description?: string;
  onSuccess?: (email: string) => Promise<unknown> | unknown;
};

export const UpdateSignInEmailFlow = ({
  isOpen,
  onClose,
  onAbandon,
  currentEmail,
  title = 'Add email to log in',
  description = 'Enter an email address to use for secure login with a verification code.',
  onSuccess,
}: Props) => {
  const { step, goToCodeVerification, handleClose, commitEmailChange } =
    useUpdateSignInEmailFlow({ isOpen, onClose, onAbandon, onSuccess });

  const isAtCodeVerificationStep = step.name === STEP_NAME.CODE_VERIFICATION;

  if (isAtCodeVerificationStep) {
    return (
      <CodeVerificationModal
        isOpen={isOpen}
        email={step.email}
        onClose={handleClose}
        onSuccessfulCodeVerification={(token) =>
          commitEmailChange(step.email, token)
        }
      />
    );
  }

  return (
    <EmailPromptModal
      isOpen={isOpen}
      onClose={handleClose}
      currentEmail={currentEmail}
      title={title}
      description={description}
      onSubmit={({ email: submittedEmail }) =>
        goToCodeVerification(submittedEmail)
      }
    />
  );
};
